export default __webpack_public_path__ + "static/media/distance-to.5fa2ee1e.svg";